// src/api/clientService.js
import api from "./api";

// ==== LOCATION via ClientController ====

export const getCountries = async () =>
    (await api.get("/Client/countries")).data;

export const getCities = async () =>
    (await api.get("/Client/cities")).data;

export const getPostalCodes = async () =>
    (await api.get("/Client/postal-codes")).data;

export const getAddresses = async () =>
    (await api.get("/Client/addresses")).data;

// optional client-side filtering
export const getCitiesByCountry = async (countryId) => {
    const cities = await getCities();
    const id = Number(countryId);
    return cities.filter((c) => Number(c.countryId) === id);
};

export const getPostalCodesByCity = async (cityId) => {
    const postalCodes = await getPostalCodes();
    const id = Number(cityId);
    return postalCodes.filter((p) => Number(p.cityId) === id);
};

export const getAddressesByPostalCode = async (postalCodeId) => {
    const addresses = await getAddresses();
    const id = Number(postalCodeId);
    return addresses.filter((a) => Number(a.postalCodeId) === id);
};

// ==== CURRENT CLIENT PROFILE ====

export const getMyClient = async () =>
    (await api.get("/Client/me")).data;

export const createOrUpdateMyClient = async (data) =>
    (await api.post("/Client/me", data)).data;

// ==== CLIENT MANAGEMENT ====

export const getClients = async () =>
    (await api.get("/Client/all")).data;

export const getClient = async (id) =>
    (await api.get(`/Client/${id}`)).data;

export const createClient = async (data) =>
    (await api.post("/Client/create", data)).data;

export const updateClient = async (data) =>
    (await api.put("/Client/update", data)).data;

export const deleteClient = async (id) =>
    (await api.delete(`/Client/delete/${id}`)).data;

// ==== LEGAL ENTITIES ====

export const getLegalEntities = async () =>
    (await api.get("/LegalEntity")).data;

export default {
    getCountries,
    getCities,
    getPostalCodes,
    getAddresses,
    getCitiesByCountry,
    getPostalCodesByCity,
    getAddressesByPostalCode,
    getMyClient,
    createOrUpdateMyClient,
    getClients,
    getClient,
    createClient,
    updateClient,
    deleteClient,
    getLegalEntities,
};